<!-- MODAL HEADER-->
<div class="row modal-bar">

  <div class="col-sm-6">
    <h5 class="modal-title">{{ passedData.title }}</h5>
  </div>

  <div class="col-sm-6">

    <div class="modal-actions">
      <div class="modal-close">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
      </div>
    </div>
  </div>
</div>


<form [formGroup]="mainForm" class="form-content">
  <div class="section-wrapper">

    @if (!allowProfileEdit) {
      <div class="row">
        <div class="col-12">
          <t4-page-warning warning="{{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.RELATION-IS-LINKED-TO' | translate}} {{this.customer.PrimaryContact.SSOProvider}} {{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.SINGLE-SIGN-ON' | translate}} {{this.customer.PrimaryContact.SSOProvider}} {{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.BE-MODIFIED' | translate}}"></t4-page-warning>
        </div>
      </div>
    }

    @if (this.customer.PrimaryContact && this.customer.PrimaryContact.AccountingId != null) {
      <div class="row">
        <div class="col-12">
          <t4-page-warning warning="{{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.RELATION-IS-LINKED-TO' | translate}} {{this.customer.PrimaryContact.AccountingProvider}}. {{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.DATA-CAN-ONLY' | translate}} {{this.customer.PrimaryContact.AccountingProvider}} {{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.BE-MODIFIED' | translate}}"></t4-page-warning>
        </div>
      </div>
    }

    @if (this.customer.PrimaryContact && this.customer.PrimaryContact.IsPlaceholder) {
      <div class="row">
        <div class="col-12">
          <t4-page-warning warning="{{'DIALOGS.EDIT-CUSTOMER.FORM.WARNING.PLACEHOLDER' | translate}}"></t4-page-warning>
        </div>
      </div>
    }

    <div class="form-layout row">
      <div class="col">
        @if (canDegradeAccountToUnderlying) {
          <div class="row">
            <div class="col">
              <button (click)="degradeAccountToUnderlying()" class="btn btn-block btn-primary bd-0">
                <span>{{ 'GENERIC.BUTTON.DEGRADE' | translate }}</span>
              </button>
            </div>
          </div>
        }


        <h6 class="form-header h6-icon">
          {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.CUSTOMERINFO' | translate }}
        </h6>

        <div class="row">
          <div class="col">
            <div class="row">
              <div class="form-group col-4">
                <label class="form-control-label">
                  {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.CUSTOMERTYPE' | translate }}@if (isRequiredField('CustomerType')) {
                  <span class="tx-danger">*</span>
                }
              </label>
              <ng-select [items]="customerTypes" bindLabel="viewValue" bindValue="value"
                formControlName="CustomerType" placeholder="{{ 'RELATIONS.EDITDIALOG.FORM.PLACEHOLDER.CUSTOMERTYPE' | translate }}" [clearable]="false"
              notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body"></ng-select>
              <t4-display-validation controlName="CustomerType" [form]="mainForm" [messages]="validationMessages">
              </t4-display-validation>
            </div>

            @if (mainForm.controls.CustomerType.value == '1') {
              <div class="form-group col-8">
                <label class="form-control-label">
                  {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.ACCOUNTMANAGER' | translate }}@if (isRequiredField('AccountManagerId')) {
                  <span class="tx-danger">*</span>
                }
              </label>
              <ng-select [items]="accountManagers" bindLabel="Name" bindValue="Id" formControlName="AccountManagerId"
                placeholder="{{ 'RELATIONS.EDITDIALOG.FORM.PLACEHOLDER.ACCOUNTMANAGER' | translate }}" [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body">
              </ng-select>
              <t4-display-validation controlName="AccountManagerId" [form]="mainForm"
              [messages]="validationMessages"></t4-display-validation>
            </div>
          }
        </div>

        <div class="row">
          @if (mainForm.controls.CustomerType.value == '1') {
            <div class="form-group col-4">
              <label class="form-control-label">
                {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.COMPANYNAME' | translate }}@if (isRequiredField('Name')) {
                <span class="tx-danger">*</span>
              }
            </label>
            <input class="form-control" name="name" formControlName="Name">
            <t4-display-validation controlName="Name" [form]="mainForm" [messages]="validationMessages">
            </t4-display-validation>
          </div>
        }

        @if (mainForm.controls.CustomerType.value == '1') {
          <div class="form-group col-4">
            <label class="form-control-label">
              {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.KVK' | translate }} @if (isRequiredField('COC')) {
              <span class="tx-danger">*</span>
            }
          </label>
          <input class="form-control" name="coc" formControlName="COC">
        </div>
      }

      @if (mainForm.controls.CustomerType.value == '1') {
        <div class="form-group col-4">
          <label class="form-control-label">
            {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.VAT' | translate }}@if (isRequiredField('VATNr')) {
            <span class="tx-danger">*</span>
          }
        </label>
        <input class="form-control" name="name" formControlName="VATNr">
      </div>
    }
  </div>
  <div class="row">
    <div class="form-group col-4">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.TELEPHONE' | translate }}@if (isRequiredField('TelephoneNr')) {
        <span class="tx-danger">*</span>
      }
    </label>
    <input class="form-control" name="TelephoneNr" formControlName="TelephoneNr">
    <t4-display-validation controlName="TelephoneNr" [form]="mainForm" [messages]="validationMessages">
    </t4-display-validation>
  </div>

  @if (mainForm.controls.CustomerType.value == '1') {
    <div class="form-group col-4">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.EXTERNALCODE' | translate }}@if (isRequiredField('ExternalCode')) {
        <span class="tx-danger">*</span>
      }
    </label>
    <input class="form-control" name="ExternalCode" formControlName="ExternalCode">
    <t4-display-validation controlName="ExternalCode" [form]="mainForm" [messages]="validationMessages">
    </t4-display-validation>
  </div>
}
</div>
</div>
</div>
</div>
</div>

<!-- Address & Primary account -->
<div class="form-layout row">
  <div class="col-12 col-lg-6">
    <h6 class="form-header h6-icon">
      {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.ADDRESS' | translate }}
    </h6>

    <div class="form-group" [formGroup]="Address">
      <div class="row">
        <div class="form-group col-4">
          <label class="form-control-label">
            {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.POSTALCODE' | translate }}@if (isRequiredField('PostalCode', Address)) {
            <span class="tx-danger">*</span>
          }
        </label>
        <input class="form-control" name="PostalCode" (change)="checkPostalCode(false)"
          formControlName="PostalCode">
          <t4-display-validation controlName="PostalCode" [form]="Address" [messages]="validationMessages">
          </t4-display-validation>
        </div>
        <div class="form-group col-5">
          <label class="form-control-label">
            {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.STREETNR' | translate }}@if (isRequiredField('StreetNr', Address)) {
            <span class="tx-danger">*</span>
          }
        </label>
        <input class="form-control" name="StreetNr" (change)="checkPostalCode(false)" formControlName="StreetNr">
        <t4-display-validation controlName="StreetNr" [form]="Address" [messages]="validationMessages">
        </t4-display-validation>
      </div>
      <div class="form-group col-3">
        <label class="form-control-label">
          {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.STREETADDITION' | translate }}@if (isRequiredField('StreetNrAddition', Address)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="streetNrAddition" (change)="checkPostalCode(false)" formControlName="StreetNrAddition">
    </div>
  </div>
  <div class="row">
    <div class="form-group col-6">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.STREET' | translate }}@if (isRequiredField('Street', Address)) {
        <span class="tx-danger">*</span>
      }
    </label>
    <input class="form-control" name="street" formControlName="Street">
    <t4-display-validation controlName="Street" [form]="Address" [messages]="validationMessages">
    </t4-display-validation>
  </div>
  <div class="form-group col-6">
    <label class="form-control-label">
      {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.CITY' | translate }} @if (isRequiredField('City', Address)) {
      <span class="tx-danger">*</span>
    }
  </label>
  <input class="form-control" name="city" formControlName="City">
  <t4-display-validation controlName="City" [form]="Address" [messages]="validationMessages">
  </t4-display-validation>
</div>
</div>
<div class="row">
  <div class="form-group col">
    <label class="form-control-label">
      {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.COUNTRY' | translate }}@if (isRequiredField('CountryId', Address)) {
      <span class="tx-danger">*</span>
    }
  </label>
  <ng-select [items]="countries" bindLabel="Name" bindValue="Id" formControlName="CountryId"
    placeholder="{{ 'RELATIONS.EDITDIALOG.FORM.PLACEHOLDER.COUNTRY' | translate }}" [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body">
    <!-- Selected item -->
    <ng-template ng-label-tmp let-item="item">
      {{ item.Iso2 ? (('COUNTRY.'+item.Iso2) | translate) : ""}}
    </ng-template>
    <!-- Dropdown items -->
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      {{('COUNTRY.'+item.Iso2) | translate}}
    </ng-template>
  </ng-select>
  <t4-display-validation controlName="CountryId" [form]="Address" [messages]="validationMessages">
  </t4-display-validation>
</div>
</div>
</div>
</div>
<div class="col-12 col-lg-6">
  <h6 class="form-header h6-icon">
    {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.PRIMARY-ACCOUNT' | translate }}
  </h6>
  <div class="form-group" [formGroup]="PrimaryContact">
    <div class="row">
      <div class="col-3 form-group">
        <label class="form-control-label">
          {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.GENDER' | translate }}@if (isRequiredField('Gender', PrimaryContact)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <ng-select [items]="selectableGenders" bindLabel="viewValue" bindValue="value" formControlName="Gender"
        placeholder="{{ 'RELATIONS.EDITDIALOG.FORM.PLACEHOLDER.GENDER' | translate }}" [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body">
      </ng-select>
      <t4-display-validation controlName="Gender" [form]="PrimaryContact" [messages]="validationMessages">
      </t4-display-validation>
    </div>
    <div class="col-5 form-group">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.FIRSTNAME' | translate }} @if (isRequiredField('FirstName', PrimaryContact)) {
        <span class="tx-danger">*</span>
      }
    </label>
    <input class="form-control" name="firstname" formControlName="FirstName">
    <t4-display-validation controlName="FirstName" [form]="PrimaryContact" [messages]="validationMessages">
    </t4-display-validation>
  </div>

  <div class="col-4 form-group">
    <label class="form-control-label">
      {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.INITIALS' | translate }}@if (isRequiredField('Initials', PrimaryContact)) {
      <span class="tx-danger">*</span>
    }
  </label>
  <input class="form-control" name="initials" formControlName="Initials">
  <t4-display-validation controlName="Initials" [form]="PrimaryContact" [messages]="validationMessages">
  </t4-display-validation>
</div>
</div>

<div class="row">
  <div class="col-3 form-group">
    <label class="form-control-label">
      {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.MIDDLENAME' | translate }}@if (isRequiredField('MiddleName', PrimaryContact)) {
      <span class="tx-danger">*</span>
    }
  </label>
  <input class="form-control" name="middlename" formControlName="MiddleName">
</div>

<div class="col-9 form-group">
  <label class="form-control-label">
    {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.LASTNAME' | translate }}@if (isRequiredField('LastName', PrimaryContact)) {
    <span class="tx-danger">*</span>
  }
</label>
<input class="form-control" name="lastname" formControlName="LastName">
<t4-display-validation controlName="LastName" [form]="PrimaryContact" [messages]="validationMessages">
</t4-display-validation>
</div>
</div>

<div class="row">
  <div class="col-8 form-group">
    <label class="form-control-label">
      {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.TELEPHONE' | translate }}@if (isRequiredField('MobileNr', PrimaryContact)) {
      <span class="tx-danger">*</span>
    }
  </label>
  <input class="form-control" name="phonenumber" formControlName="MobileNr">
  <t4-display-validation controlName="MobileNr" [form]="PrimaryContact" [messages]="validationMessages">
  </t4-display-validation>
</div>
<div class="form-group col-4 parsley-input parsley-error">
  <label class="form-control-label">
    {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.DATEOFBIRTH' | translate }}@if (isRequiredField('DateOfBirth', PrimaryContact)) {
    <span class="tx-danger">*</span>
  }
</label>
<input class="form-control" datepicker [beforeToday]="true" formControlName="DateOfBirth">
<t4-display-validation controlName="DateOfBirth" [form]="PrimaryContact" [messages]="validationMessages">
</t4-display-validation>
</div>
</div>

<div class="row">
  <div class="col-8 form-group">
    <label class="form-control-label">
      {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.EMAIL' | translate }}@if (isRequiredField('Email', PrimaryContact)) {
      <span class="tx-danger">*</span>
    }
  </label>
  <input trim class="form-control" name="email" formControlName="Email">
  <t4-display-validation controlName="Email" [form]="PrimaryContact" [messages]="validationMessages">
  </t4-display-validation>
</div>
<div class="col-4 form-group">
  <label class="form-control-label">
    {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.LANGUAGE' | translate }}

  </label>
  <ng-select [items]="SelectableLanguages" bindLabel="Name" bindValue="Id" formControlName="LanguageId" placeholder="{{ 'RELATIONS.EDITDIALOG.FORM.PLACEHOLDER.DEFAULT' | translate }}"
  [clearable]="true" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body"></ng-select>
  <t4-display-validation controlName="LanguageId" [form]="PrimaryContact" [messages]="validationMessages"></t4-display-validation>
</div>
</div>
@if (this.isUsingSASSO) {
  <div class="row">
    <div class="col-12 form-group">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.SSOID' | translate }}
      </label>
      <div class="row">
        <div class="col-8 form-group">
          <input trim class="form-control" name="ssoid" formControlName="SSOId">
        </div>
        @if (this.customer.PrimaryContact && this.customer.PrimaryContact.SSOId) {
          <div class="col-4 form-group">
            <button (click)="deleteSSOId()" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline" style="margin-top: 6px;"></button>
          </div>
        }
      </div>
    </div>
  </div>
}
</div>
</div>
</div>

<!-- Buttons -->
<div class="row">

  <div class="col-6">
    <button (click)="submit()" [disabled]="!customerIsValidAndDirty()" class="btn btn-block btn-primary bd-0">
      <i class="far fa-save"></i>
      <span>{{ 'GENERIC.BUTTON.SAVE' | translate }}</span>
    </button>
  </div>
  <div class="col-6">
    <button (click)="dialogRef.close(false);" class="btn btn-block btn-secondary bd-0">
      <i class="fas fa-ban"></i>
      <span>{{ 'GENERIC.BUTTON.CANCEL' | translate }}</span>
    </button>
  </div>
</div>
</div>
</form>
